module.exports = __webpack_public_path__ + "static/media/stopwatch.40925704.png";